export const ACTIVITY_QUERY = 'ACTIVITY_QUERY';
export const GET_ISSUE_ACTIVITIES_QUERY = 'GET_ENTRY_ACTIVITIES_QUERY';
export const GET_UNRESOLVED_ISSUES_QUERY = 'GET_UNRESOLVED_ISSUES_QUERY';
export const GET_ALL_ACTIVITIES_QUERY = 'GET_ALL_ACTIVITIES_QUERY';